<template>
  <div class="availability">
    <form-availability 
      :editTMP="editTMP"
    />
  </div>
</template>
<script>
  import FormAvailability from './FormAvailability'
  export default {
    components: {
      FormAvailability
    },
    props: {
      editTMP: {
        type: Object,
        require: true
      },
      onCancel: {
        type: Function,
        require: true
      }
    },
    data () {
      return {
        switch1: true,
        switch2: false,
      }
    },
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      }
    }
  }
</script>
<style lang="scss" scoped>
  .availability {
    padding: 15px;
    // width: calc(100% + 30px);
    background-color: #f3f0f0;
    // margin-left: -15px;
    // margin-right: -15px;
  }
</style>
